import React, { Component } from 'react'
import { translation } from '../../../utils/helpers'
import './orangeDivider.scss'

class OrangeDivider extends Component {
  getSizeClass () {
    if (typeof this.props.size === 'number' && this.props.size > 0 && this.props.size < 7) {
      return `pg-my-${this.props.size}`
    }

    return 'pg-my-1'
  }

  render () {
    let classes = 'element-divider-orange ' + this.getSizeClass()
    return (
      <div className={classes}>
        <hr />
        <div>{translation(this.props.labelText)}</div>
        <hr />
      </div>
    )
  }
}

OrangeDivider.defaultProps = {
  size: 1
}

export default OrangeDivider



// WEBPACK FOOTER //
// ./src/app/shared/elements/orangeDivider/index.js